var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.getClass(_vm.dashboardLayoutCard.dashboardCardTypeCode, _vm.dashboardLayoutCard.sequenceNumber) + ' dashboard-welcome'},[_c('div',{staticClass:"dashboard-card-body"},[_c('dashboard-welcome-slider')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }